<!--
  Story-Karte: dezenter Rahmen+heller Hintergrund statt kräftiger Farbfläche, "Neu"-Badge inline
  in der Kopfzeile, Match-Name zweizeilig statt abgeschnitten, kleine Länderflagge in der
  Kopfzeile. <button> statt <a> - kein Anchor-Default-Styling zu bekämpfen, war eh nie eine
  echte Navigation, nur ein per Klick abgefangenes Custom-Event.

  WICHTIG: KEIN <style scoped> hier - die Styles (.story-card*) liegen in der gemeinsamen
  style.css, weil scoped-Styles bei defineCustomElement NICHT automatisch ins Shadow DOM
  gelangen (landen normalerweise im <head>, das Shadow Root bekommt aber nur, was explizit
  über styles:[styles] in register.js reingereicht wird).
-->
<template>
  <button type="button" class="story-card" @click="$emit('open')">
    <div class="story-card__kopf">
      <span v-if="isLive" class="story-card__live-dot" aria-label="Live"></span>
      <img v-if="flaggeBild" :src="flaggeBild" :class="['story-card__flagge', `story-card__flagge--${flaggeGroesse}`]" alt="" />
      <span v-if="phaseLabel" :class="['story-card__phase', `story-card__phase--${phase}`]">{{ phaseLabel }}</span>
      <span v-if="isNew" class="story-card__neu">N</span>
      <span class="story-card__spacer"></span>
      <span v-if="infoText" class="story-card__info">{{ infoText }}</span>
    </div>
    <span class="story-card__label">{{ matchLabel }}</span>
  </button>
</template>

<script setup>
defineProps({
  matchLabel: {
    type: String,
    required: true
  },
  isNew: {
    type: Boolean,
    default: false
  },
  // Unterscheidet Vorschau-/Bericht-Karten optisch (zwei Karten können zum selben Match gehören)
  // Roher Phase-Schlüssel (z.B. 'preview'/'report'/'story'/'rumor') - für den CSS-Modifier,
  // robuster als aus dem übersetzten phaseLabel-Text abzuleiten.
  phase: {
    type: String,
    default: 'preview'
  },
  phaseLabel: {
    type: String,
    default: ''
  },
  // Ergebnis, wenn das Match completed ist - sonst Anstoß-Tag+Zeit (z.B. "DO 12:00")
  infoText: {
    type: String,
    default: ''
  },
  isLive: {
    type: Boolean,
    default: false
  },
  // Länderflagge - analog zu match.ligaFlaggeBild, kommt aber aus der Story selbst (eigenes
  // Feld, nicht vom Match abgeleitet, da die Story-Karte kein volles Match-Objekt hat).
  flaggeBild: {
    type: String,
    default: null
  },
  // Größenstufe der Flagge: 'standard' | 'large' | 'xl' - gleiche Struktur wie
  // ligaLogoGroesse() in lib/ligaTypen.js, hier aber als Prop statt automatisch berechnet
  // (der Aufrufer entscheidet, welche Flagge größer dargestellt werden soll).
  flaggeGroesse: {
    type: String,
    default: 'standard'
  }
})

defineEmits(['open'])
</script>